import { Spinner } from 'react-bootstrap';

interface Props {
  size?: 'sm';
  class?: string;
}

export function CustomSpinner(props: Readonly<Props>) {
  return (
    <div className={props.class}>
      <output aria-live="polite">
        <Spinner animation="border" size={props.size} />
        <span className="visually-hidden">Loading...</span>
      </output>
    </div>
  );
}
